/**
 * Created by AlexanderC on 5/27/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Resource = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Extractable2 = require('./Extractable');

var _Region = require('../Region');

var _Service = require('../Service');

var _InvalidArgumentException = require('../../Exception/InvalidArgumentException');

var _InvalidArnException = require('./Exception/InvalidArnException');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * IAM statement resource
 */
let Resource = exports.Resource = function (_Extractable) {
  _inherits(Resource, _Extractable);

  function Resource() {
    let service = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Service.Service.ANY;
    let region = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    let accountId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    let descriptor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    _classCallCheck(this, Resource);

    var _this = _possibleConstructorReturn(this, (Resource.__proto__ || Object.getPrototypeOf(Resource)).call(this));

    _this._service = null;
    _this._region = null;
    _this._accountId = accountId;
    _this._descriptor = descriptor;

    _this.service = service;
    _this.region = region;

    _this._any = false;
    return _this;
  }

  /**
   * @returns {Resource}
   */


  _createClass(Resource, [{
    key: 'any',
    value: function any() {
      this._any = true;
      return this;
    }

    /**
     * @param {String} identifier
     */

  }, {
    key: 'updateFromArn',


    /**
     * @see - http://docs.aws.amazon.com/general/latest/gr/aws-arns-and-namespaces.html
     *
     * @param {string} arn
     * @returns {Resource}
     */
    value: function updateFromArn(arn) {
      let arnParts = arn.split(':');

      if (arnParts.length < 6) {
        throw new _InvalidArnException.InvalidArnException(arn);
      }

      this.service = arnParts[2];
      this.region = arnParts[3];
      this.accountId = arnParts[4];
      this.descriptor = arnParts.slice(5).join(':');

      return this;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'extract',
    value: function extract() {
      if (this._any) {
        return '*';
      }

      let service = this._service;
      let region = this._region;
      let accountId = this._accountId;
      let descriptor = this._descriptor;

      return `arn:aws:${service}:${region}:${accountId}:${descriptor}`;
    }
  }, {
    key: 'accountId',
    set: function set(identifier) {
      this._accountId = identifier;
    }

    /**
     * @returns {String}
     */
    ,
    get: function get() {
      return this._accountId;
    }

    /**
     * @param {String} descriptor
     */

  }, {
    key: 'descriptor',
    set: function set(descriptor) {
      this._descriptor = descriptor;
    }

    /**
     * @returns {String}
     */
    ,
    get: function get() {
      return this._descriptor;
    }

    /**
     * @param {String} name
     */

  }, {
    key: 'region',
    set: function set(name) {
      if (!_Region.Region.exists(name)) {
        throw new _InvalidArgumentException.InvalidArgumentException(name, _Region.Region);
      }

      this._region = name;
    }

    /**
     * @returns {String}
     */
    ,
    get: function get() {
      return this._region;
    }

    /**
     * @param {String} name
     */

  }, {
    key: 'service',
    set: function set(name) {
      if (!_Service.Service.exists(name)) {
        throw new _InvalidArgumentException.InvalidArgumentException(name, _Service.Service);
      }

      this._service = name;
    }

    /**
     * @returns {String}
     */
    ,
    get: function get() {
      return this._service;
    }
  }]);

  return Resource;
}(_Extractable2.Extractable);


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/AWS/IAM/Resource.js
// module id = 162
// module chunks = 0